import React from 'react';
import config from '../../config';

function DepartmentsPageHeader() {
  return (
    <section className="page-header">
      <div 
        className="page-header-bg" 
        style={{ backgroundImage: "url(assets/images/backgrounds/ABAheader--1894-434.jpg)" }}
      >
      </div>
      <div className="container">
        <div className="page-header__inner">
          <h2>Applied Behavioral Analysis</h2>
          <ul className="thm-breadcrumb list-unstyled">
                        <li><a href="/">Home</a></li>
                        <li><span>/</span></li>
                        <li><a href="">Departments</a></li>
                        <li><span>/</span></li>
                        <li>Applied Behavioral Analysis</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default DepartmentsPageHeader;